import { extract_saved_answers, normalize_text } from '@/services/onboarding_form_helpers';

function normalize_field_label(value) {
  return normalize_text(String(value || '').replace(/[_-]+/g, ' '));
}

function get_check_forms(context) {
  if (typeof context.get_case_forms_for_check === 'function') {
    return context.get_case_forms_for_check(context.item);
  }

  return [];
}

function get_answer_label(answer = {}) {
  const label = normalize_field_label(answer?.question_label || answer?.label || answer?.question_text || '');
  return label;
}

function answer_matches_field(answer = {}, field = {}) {
  const answer_label = get_answer_label(answer);
  const field_label = normalize_field_label(field.label || field.key);
  const field_key = normalize_field_label(field.key);
  const possible_matches = [field_label, field_key].filter(Boolean);
  const matches = possible_matches.some((value) => (
    answer_label === value || answer_label.includes(value)
  ));
  return matches;
}

function get_answer_text(answer = {}) {
  const answer_text = [answer?.answer_text, answer?.answer, answer?.value].find(Boolean);
  return String(answer_text || '').trim();
}

function get_form_saved_answers(form = {}) {
  const saved_answers = extract_saved_answers(form?.application_form || form);
  return saved_answers;
}

function find_answer_in_form(form, field) {
  const saved_answers = get_form_saved_answers(form);
  const matched_answer = saved_answers.find((answer) => answer_matches_field(answer, field));
  const answer_text = get_answer_text(matched_answer);
  return answer_text;
}

export function find_submitted_verification_answer(context, field = {}) {
  const forms = get_check_forms(context);

  for (const form of forms) {
    const answer_text = find_answer_in_form(form, field);
    if (answer_text) return answer_text;
  }

  return '';
}
